module.exports = __webpack_public_path__ + "static/media/eur_logo.008d7ed4.svg";